import React from 'react';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import useLayoutVariables from '../../../hooks/useLayoutVariables';
import type { ParagraphWebform as Type } from '../../../types/uncinc_profile/paragraphs';
import Webform from '../../Webform';

import './style.scss';

interface ParagraphWebformProps {
  id: string;
  entity: ImmutableEntity<Type>;
}

const ParagraphWebform: React.FC<ParagraphWebformProps> = ({ id, entity }) => {
  const {
    textColClasses,
    webformColClasses,
  } = useLayoutVariables('paragraphWebform');

  const paragraphWebform = entity.toJS();
  const title = paragraphWebform.field_title[0]?.value;
  const body = paragraphWebform.field_body[0]?.processed;
  const { value: targetId } = paragraphWebform.field_webform[0];

  return (
    <div id={id} className="Paragraph ParagraphWebform">
      <Container>
        <div className="row">
          {(title || body) && (
            <div className={textColClasses}>
              {title && (
                <h2 className="ParagraphWebform__title">
                  {title}
                </h2>
              )}

              {body && (
                <WysiwygField
                  className="ParagraphWebform__body"
                  html={body}
                />
              )}
            </div>
          )}

          <div className={webformColClasses}>
            <Webform
              id={targetId}
              onlySubmitVisibleFields
              scrollToTopAfterMultiFormStep={false}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphWebform;
